"use strict";

const body = document.querySelector('body');

// Main navigation

const mainNavToggle = document.querySelector('.main-nav-toggle');
const mainNav = document.querySelector('.main-nav');

mainNavToggle.addEventListener('click', function(){
  this.classList.toggle('is-selected');
  mainNav.classList.toggle('is-open');
  console.log('clicked');
});

// Product filters

const toggleFilters = document.querySelector('.product-filters-toggle');
const closeFilters = document.querySelector('.close-filters');
const filters = document.querySelector('.product-filters');
const filterGroups = document.querySelectorAll('.filter-group');

if(toggleFilters) {
  toggleFilters.addEventListener('click', function(){
    filters.classList.toggle('is-visible');
    body.classList.toggle('no-scroll');
  })
}

if(closeFilters) {
  closeFilters.addEventListener('click', function(){
    filters.classList.toggle('is-visible');
    body.classList.toggle('no-scroll');
  })
}

filterGroups.forEach(function(filterGroup) {
  const filterToggle = filterGroup.querySelector('.filter-toggle');
  const filters = filterGroup.querySelector('.filters');

  filterToggle.addEventListener('click', function(){
    this.classList.toggle('is-selected');
    filters.classList.toggle('is-open');
  })
});

// Product image gallery

const productGalleryOuter = document.querySelector('.product-gallery-outer');
const productGallery = document.querySelector('.product-gallery');

if(productGallery) {
  const productGalleryPrev = productGalleryOuter.querySelector('.product-gallery-control--prev');
  const productGalleryNext = productGalleryOuter.querySelector('.product-gallery-control--next');

  const productGallerySlides = tns({
    container: productGallery,
    mode: 'carousel',
    items: 1,
    slideBy: 'page',
    autoplay: false,
    autoplayButtonOutput: false,
    speed: 500,
    controls: true,
    nav: false,
    mouseDrag: true,
    prevButton: productGalleryPrev,
    nextButton: productGalleryNext,
  });

}

// Blog filters

const blogFeed = document.querySelector('.feed--blog');

if (blogFeed) {
  const mixer = mixitup(blogFeed, {
    animation: {
      enable: false,
      animateResizeContainer: false
    },
    // pagination: {
    //   limit: 12,
    //   hidePageListIfSinglePage: true,
    //   loop: true
    // },
    // selectors: {
    //   pageList: '.pagination',
    //   target: targetSelector
    // },
    // load: {
    //   filter: getSelectorFromHash() // Ensure that the mixer's initial filter matches the URL on startup
    // },
    // callbacks: {
    //   onMixEnd: setHash // Call the setHash() method at the end of each operation
    // },
    // templates: {
    //   pagerPrev:
    //     '<button type="button" class="${classNames} pg-prev" data-page="prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><title>arrow</title><polygon points="73.23 23.23 69.7 26.77 90.43 47.5 0 47.5 0 52.5 90.43 52.5 69.7 73.23 73.23 76.77 100 50 73.23 23.23"/></svg></button>',
    //   pagerNext:
    //     '<button type="button" class="${classNames} pg-next" data-page="next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><title>arrow</title><polygon points="73.23 23.23 69.7 26.77 90.43 47.5 0 47.5 0 52.5 90.43 52.5 69.7 73.23 73.23 76.77 100 50 73.23 23.23"/></svg></button>',
    //   pager:
    //     '<button type="button" class="${classNames} pg-number" data-page="${pageNumber}">${pageNumber}</button>'
    // }
  });
}

// Product filters

const productFeed = document.querySelector('.product-feed .feed');

if(productFeed) {
  const mixer = mixitup(productFeed, {
    animation: {
      enable: false,
      animateResizeContainer: false
    },
    multifilter: {
      enable: true
    }
  })
}

const resetProductFilters = document.querySelector('.reset-filters');
const activeElements = document.querySelectorAll('.filter');

resetProductFilters.addEventListener('click', function(){
  activeElements.forEach(function(element){
    if(element.classList.contains('mixitup-control-active')){
      element.classList.remove('mixitup-control-active');
    }
  });
});


// Wait for the DOM to fully load
document.addEventListener('DOMContentLoaded', function() {
  console.log('a');

  // Get the response output element (where CF7 shows success/failure messages)
  var responseMessage = document.querySelector('.wpcf7-response-output');

  console.log(responseMessage);

  // Check if the response message contains the phrase "Thank you"
  if (responseMessage && responseMessage.textContent.includes('Thank you')) {
    console.log('b');
    // Hide the form
    var form = document.querySelector('.newsletter-signup__form');
    if (form) {
        form.style.display = 'none';
    }

    // Show the custom success message
    var successMessage = document.querySelector('.newsletter-signup-success');
    if (successMessage) {
        successMessage.style.display = 'block';
    }
  }
});